var map = {
	"./PastContainer": 2999,
	"./PastContainer.css": 8971,
	"./PastContainer.js": 2999,
	"./SliderTimeline": 8709,
	"./SliderTimeline.css": 2285,
	"./SliderTimeline.js": 8709,
	"./TimelineInstance": 8021,
	"./TimelineInstance.css": 8758,
	"./TimelineInstance.js": 8021,
	"./assets/brain.jpg": 3132,
	"./assets/design-small.png": 9040,
	"./assets/personal-assistant.jpg": 9201,
	"./assets/phone.jpg": 6597,
	"./assets/travel.jpg": 883,
	"./projects/ProjectContainer": 5751,
	"./projects/ProjectContainer.js": 5751,
	"./projects/ProjectContainer.module.css": 5305,
	"./projects/ProjectDiscopop": 9901,
	"./projects/ProjectDiscopop.js": 9901,
	"./projects/ProjectDnD": 6357,
	"./projects/ProjectDnD.js": 6357,
	"./projects/ProjectItem": 7200,
	"./projects/ProjectItem.css": 4549,
	"./projects/ProjectItem.js": 7200,
	"./projects/ProjectPawly": 8777,
	"./projects/ProjectPawly.js": 8777,
	"./projects/ProjectSlider": 8969,
	"./projects/ProjectSlider.js": 8969,
	"./projects/ProjectThesis": 4852,
	"./projects/ProjectThesis.css": 5247,
	"./projects/ProjectThesis.js": 4852,
	"./projects/Projects.css": 1296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9447;